import React, { useEffect, useState } from "react";

export interface RadioGroupOption {
  label: string;
  key: string;
}

interface RadioGroupProps {
  options: RadioGroupOption[];
  onSelect: (value: string) => void;
  disabled?: boolean;
  isMeasuring?: boolean;
}

export const RadioGroup = (props: RadioGroupProps) => {
  const [selected, setSelected] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelected(value);
    props.onSelect(value);
  };

  useEffect(() => {
    if (!props.isMeasuring) {
      setSelected("");
    }
  }, [props.isMeasuring]);

  return (
    <div className="flex flex-wrap gap-4">
      {props.options.map((option) => {
        const isSelected = selected === option.key;
        const isDisabled = props.disabled;

        return (
          <label
            key={option.key}
            className={`flex items-center space-x-2 cursor-pointer p-1 border rounded-lg ${
              isDisabled && isSelected
                ? "bg-gray-300 border-gray-500 text-gray-700"
                : "hover:bg-gray-400"
            }`}
          >
            <input
              type="radio"
              value={option.key}
              checked={isSelected}
              onChange={handleChange}
              disabled={isDisabled}
              className={`form-radio h-4 w-4 cursor-pointer ${
                isDisabled && isSelected ? "text-gray-500" : "text-blue-600"
              }`}
            />
            <span
              className={`font-medium ${
                isDisabled && isSelected ? "text-gray-700" : "text-[#b0e0e6]"
              }`}
              dangerouslySetInnerHTML={{ __html: option.label }}
            />
          </label>
        );
      })}
    </div>
  );
};
